/* eslint-disable consistent-return */
/* eslint-disable react/destructuring-assignment */
import React, { Component, forwardRef } from 'react';
import { Row, Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { connect } from 'react-redux';
import { addUserChange, addUserCompanyFilter } from '../actions/Users';
import { getCompanies, getCompanyGroup } from '../actions/Companies';
import DropdownSelect from './ProposalGenerator/DropdownSelect';
import CompanyAutocomplete from '../components/CompanyAutocomplete';
import Toggle from './Toggle';
import DynamicAutoComplete from './EpikBoxes/DynamicAutoComplete';
import OptionalDropdownSelect from './OptionalDropdownSelect';
import AddSecurityCodeModal from './AddSecurityCodeModal';
import utils from '../lib/utils';
import { RESTRICTED_PERMISSION_GROUPS } from '../utils/constants';
const { USER_VALIDATION_TEXT } = require('../lib/constants')

const userItem = { label: 'User', value: 'user' };
const agentItem = { label: 'Agent', value: 'agent' };
const adminItem = { label: 'Admin', value: 'admin' };
const enterpriseItem = { label: 'Enterprise Admin', value: 'enterpriseAdmin' };
const manufacturerItem = { label: 'Manufacturer', value: 'manufacturer' };
const supportEngineerItem = { label: 'Support Engineer', value: 'supportEngineer' };
const companyGroupManagerItem = { label: 'CompanyGroupManager', value: 'companyGroupManager' };

const superAdminItems = [
  // { label: 'QuoteToolAdmin', value: 'quoteToolAdmin' },
  { label: 'CompanyGroupAdmin', value: 'companyGroupAdmin' },
];

const engineeringGroupItems = [
  ...superAdminItems,
  { label: 'SuperAdmin', value: 'superAdmin' },
];

const companyGroupAdminItems = [
  // { label: 'QuoteToolAdmin', value: 'quoteToolAdmin' },
  { label: 'CompanyGroupAdmin', value: 'companyGroupAdmin' },
];

class AddUserForm extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');

    this.state = {
      selectRole: undefined,
      dropdownOptions: [],
      selectedCompany: '',
      passwordPrompt: true,
      resetPassword: true,
      selectedCompanyGroup: [],
      securityModal: false,
      selectionTrigger: '',
      isAutoPassword: false,
      showPasswordTip: true,
      userEmail: false,
      selectedDM: null,
      name: '',
      email: '',
      password: '',
      errors: {},
      selectedPermissionGroup: '',
      permissionGroupsList: [],

    };
    this.formRef = React.createRef();
  }

  handleSubmit = async () => {
    const errors = {};
    if (this.state.name.trim() === '') {
      errors.name = USER_VALIDATION_TEXT.NAME
    }
    if (this.state.email.trim() === '') {
      errors.email = USER_VALIDATION_TEXT.EMAIL
    }
    if (!this.state.isAutoPassword && this.state.password.trim() === '') {
      errors.password = USER_VALIDATION_TEXT.PASSWORD;
    }
    if (this.state.selectedPermissionGroup === '') {
      if (this.checkPermissionGroupAccess()) {
        errors.permissionsGroup = USER_VALIDATION_TEXT.PERMISSIONS_GROUP;
      } else if (this.state.selectRole?.value !== 'user') { // it means selected role is EnterpriseAdmin or admin
        this.props.addUserChange({ name: 'permissionsGroup', value: "Customer" });
      }
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    // Call the onConfirm function passed from the parent if no errors
    this.props.onConfirm();
  };


  componentDidMount = async () => {
    const { loggedInUser, getCompanies, setCompanyFilter, companies } = this.props;
    const { resetPassword, isAutoPassword } = this.state;
    if (loggedInUser.role === 'superAdmin' || loggedInUser.role === 'companyGroupAdmin') {
      await getCompanies(this.token, undefined, 'yes');
      const company = {
        name: 'company',
        value: loggedInUser.company.name,
        suggestion: { ...loggedInUser.company },
      };
      setCompanyFilter(company);
      this.companyGroup(company);
    }
    this.onAddedUserChange({ target: { value: loggedInUser.company._id, name: 'company' } });
    this.setRoleList(loggedInUser.role, loggedInUser.company.companyType);
    this.props.addUserChange({ name: 'resetPassword', value: resetPassword });
    this.props.addUserChange({ name: 'isGeneratePassword', value: isAutoPassword });
  };

  setRoleList = (role, companyType) => {
    let dropdownOptions = [];
    if (role === 'superAdmin') {
      const superAdminOptions = this.props.user.permissionsGroup === 'Engineering' ? engineeringGroupItems : superAdminItems;
      dropdownOptions = [
        userItem,
        agentItem,
        adminItem,
        enterpriseItem,
        manufacturerItem,
        companyGroupManagerItem,
        supportEngineerItem,
        ...superAdminOptions,
      ];
    } else if (role === 'companyGroupAdmin') {
      dropdownOptions = [
        userItem,
        adminItem,
        enterpriseItem,
        manufacturerItem,
        ...companyGroupAdminItems,
      ];
    }

    const filteredItemForCompanyTypeOtherThanManufacturer =
      role === 'companyGroupAdmin'
        ? superAdminItems.filter(item => item.value === 'companyGroupAdmin')
        : (this.props.user.permissionsGroup === 'Engineering' ? engineeringGroupItems : superAdminItems);

    dropdownOptions =
      companyType === 'manufacturer'
        ? [manufacturerItem]
        : role === 'superAdmin'
          ? [
          userItem,
          agentItem,
          adminItem,
          enterpriseItem,
            manufacturerItem,
          companyGroupManagerItem,
          supportEngineerItem,
          ...filteredItemForCompanyTypeOtherThanManufacturer,
          ]
          : [
            userItem,
            adminItem,
            enterpriseItem,
            manufacturerItem,
          ...filteredItemForCompanyTypeOtherThanManufacturer,
        ];

    if (role === 'admin') {
      // dropdownOptions =
      //   companyType === 'agency'
      //     ? [agentItem, adminItem]
      //     : [userItem, adminItem];
      dropdownOptions = [userItem, adminItem];
    } else if (role === 'enterpriseAdmin') {
      // Previous agency-based options (kept for reference):
      // dropdownOptions =
      //   companyType === 'agency'
      //     ? [agentItem, adminItem, enterpriseItem]
      //     : [userItem, adminItem, enterpriseItem];
      dropdownOptions = [userItem, adminItem, enterpriseItem];
    } else if (role === 'companyGroupManager') {
      // Previous agency / selectedCompany options (kept for reference):
      // if (this.state.selectedCompany === '') {
      //   dropdownOptions = [userItem, adminItem, enterpriseItem];
      // } else {
      //   dropdownOptions =
      //     companyType === 'agency'
      //       ? [agentItem, adminItem, enterpriseItem]
      //       : [userItem, adminItem, enterpriseItem];
      // }
      dropdownOptions = [userItem, adminItem, enterpriseItem];
    }
    this.onRoleSelect(dropdownOptions[0]);
    this.setState({ dropdownOptions, selectRole: dropdownOptions[0] });
  };

  onAddedUserChange = ev => {
    const { name, value } = ev.target;
    const trimmedValue = value ? value.trim() : '';
    this.setState(prevState => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: trimmedValue === '' ? USER_VALIDATION_TEXT[name.toUpperCase()] : '',      }
    }));
    this.props.addUserChange({ name, value: value });
  };

  onEnabledChange = value => {
    this.props.addUserChange({ name: 'enabled', value: !value });
  };

  onPasswordEnabledChange = async value => {
    const { resetPassword } = this.state;
    await this.props.addUserChange({ name: 'resetPassword', value: !resetPassword });
    this.setState({ resetPassword: !resetPassword });
  };

  onCarrierHubEnabledChange = () => {
    const { portingAccessEnabled } = this.state;
    this.props.addUserChange({ name: 'portingAccessEnabled', value: !portingAccessEnabled });
    this.setState({ portingAccessEnabled: !portingAccessEnabled });
  };

  onRealTimeActivityChange = () => {
    const { realTimeActivityEnabled } = this.state;
    this.props.addUserChange({ name: 'realTimeActivityEnabled', value: !realTimeActivityEnabled });
    this.setState({ realTimeActivityEnabled: !realTimeActivityEnabled });
  };

  onDataCenterMonitorChange = () => {
    this.setState({ monitorSecurityModal: true, selectedDM: 'dataCenterMonitor' });
  };

  // onCallsAccessChange = () => {
  //   this.setState({ callsAccess: !this.state.callsAccess });
  //   this.props.addUserChange({ name: 'callsAccess', value: !this.state.callsAccess });
  // };
  onDeviceMonitorChange = () => {
    this.setState({ monitorSecurityModal: true, selectedDM: 'deviceMonitor' });
  };

  onMonitorSecurityConfirm = () => {
    const { dataCenterMonitor, deviceMonitor } = this.state;
    if (this.state.selectedDM === 'dataCenterMonitor') {
      this.props.addUserChange({ name: 'dataCenterMonitor', value: !dataCenterMonitor });
      this.setState({ dataCenterMonitor: !dataCenterMonitor });
    } else if (this.state.selectedDM === 'deviceMonitor') {
      this.props.addUserChange({ name: 'deviceMonitor', value: !deviceMonitor });
      this.setState({ deviceMonitor: !deviceMonitor });
    }
    this.setState({ monitorSecurityModal: false });
  };

  onCompanyFilter = async company => {
    const { setCompanyFilter, loggedInUser } = this.props;
    this.companyGroup(company);
    setCompanyFilter(company || {});
    if (!company || !company.value) {
      this.onAddedUserChange({ target: { value: null, name: 'company' } });
    } else {
      this.setState({ selectedCompany: company.suggestion }, () => {
        this.setRoleList(loggedInUser.role, company.suggestion.companyType);
      });
      this.onAddedUserChange({ target: { value: company.suggestion._id, name: 'company' } });
    }
  };

  companyGroup = async company => {
    const { getCompanyGroup } = this.props;
    const getGroups = await getCompanyGroup(this.token, company?.suggestion?._id);
    this.setState({ selectedCompanyGroup: getGroups });
  };

  selectedCompanies = list => {
    const idList = list.map(e => e._id);
    this.props.addUserChange({ name: 'selectedGroups', value: idList });
  };

  onRoleSelect = selectedOption => {
    const { value } = selectedOption;
    let permissionGroupsList = [...RESTRICTED_PERMISSION_GROUPS]

    this.setState({ selectRole: selectedOption });
    this.setState({ selectionTrigger: '' });
    this.props.addUserChange({ name: 'role', value });

    // set permission group Customer in-case of following roles
    if (['admin', 'enterpriseAdmin',].includes(value)) {
      this.props.addUserChange({ name: 'permissionsGroup', value: 'Customer' });
    } else if (value === 'user') {
      this.props.addUserChange({ name: 'permissionsGroup', value: '' });
    }

    this.setState({ permissionGroupsList })
  };

  onSecurityConfirm = () => {
    this.props.addUserChange({ name: 'role', value: 'superAdmin' });
    const superAdminOptions = this.props.user.permissionsGroup === 'Engineering' ? engineeringGroupItems : superAdminItems;
    this.setState({
      selectRole: superAdminOptions[0],
      selectionTrigger: 'confirm',
      securityModal: false,
      permissionGroupsList: [...RESTRICTED_PERMISSION_GROUPS]
    });
  };

  onPasswordValidate = event => {
    const { name, value } = event.target;
    const { email } = this.state;
    this.setState(prevState => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: value.trim() === '' ? USER_VALIDATION_TEXT[name.toUpperCase()] : '',
      }
    }));
    
    const isValid = email && utils.validatePassword(value, email);
    this.setState({
      password: value,
      showPasswordTip: !isValid
    })
    if (isValid) {
      this.setState({ showPasswordTip: false });
      this.props.addUserChange({ name, value });
    }
  };

  onAutoGeneratePassword = event => {
    const { name } = event.target;
    const { isAutoPassword } = this.state;
    this.setState(prevState => ({
      isAutoPassword: !prevState.isAutoPassword,
      password: '', // Clear password field if auto-generate is checked
      errors: {
        ...prevState.errors,
        password: '', // Clear password error if any
      }
    }));
    this.props.addUserChange({ name, value: !isAutoPassword });
    this.setState({ isAutoPassword: !isAutoPassword });


  };

  hidden = () => {
    if (this.props.role !== 'superAdmin') return true;
    if (this.props.user.role !== 'superAdmin') return true;
  };

  hiddenCarrier = () => {
    const { role, userRole } = this.props;
    if (
      (userRole === 'superAdmin' || userRole === 'companyGroupAdmin') &&
      (role === 'superAdmin' || role === 'companyGroupAdmin')
    ) {
      return false;
    }
    return true;
  };

  handlePermissionGroup = (value) => {
    this.setState({ selectedPermissionGroup: value });
    this.props.addUserChange({ name: 'permissionsGroup', value });
  } 

  checkPermissionGroupAccess = () => {
    const user = this.props.user;

    const selectRole = this.state.selectRole

    // not allowed to enterpriseAdmin, admin & user role
    // don't show permission group dropdown if role of loggedIn user or new user includes in following array
    const restrictedRoles = ['enterpriseAdmin', 'admin', 'user']
    if (restrictedRoles.includes(user.role) || restrictedRoles.includes(selectRole?.value)) {
      return false
    }
    return true
  }
  render() {
    const { loggedInUser, companies, companyFilter, userRole, } = this.props;
    const { selectRole, selectedCompanyGroup, selectedPermissionGroup, permissionGroupsList } = this.state;
    const { errors } = this.state;
    return (
      <form ref={this.formRef}>
        <div className="container">
          <FormGroup row>
            <Label for="name" sm={4}>
              Name:
            </Label>
            <Col sm={9}>
              <Input
                placeholder="Please specify"
                required
                type="text"
                name="name"
                value={this.props.name}
                onChange={this.onAddedUserChange}
              />
              {errors.name && <div className="error-message">{errors.name}</div>}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="email" sm={4}>
              Email:
            </Label>
            <Col sm={9}>
              <Input
                autocomplete="off"
                placeholder="Please specify"
                required
                type="email"
                name="email"
                value={this.props.email}
                onChange={this.onAddedUserChange}
              />
              {errors.email && <div className="error-message">{errors.email}</div>}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="phoneNumber" sm={4}>
              Phone Number:
            </Label>
            <Col sm={9}>
              <Input
                name="phoneNumber"
                placeholder="please specify"
                value={this.props.phoneNumber}
                onChange={e => {
                  const reg = /^[+]*[0-9]{1,11}$/g;
                  if (reg.test(e.target.value)) {
                    this.onAddedUserChange(e);
                  }
                }}
              />
            </Col>
          </FormGroup>
          <FormGroup style={{ marginLeft: '20px', marginBottom: '4px' }}>
            <Label check>
              <Input
                type="checkbox"
                name="isGeneratePassword"
                checked={this.state.isAutoPassword}
                onChange={this.onAutoGeneratePassword}
              />
              Automatically create a Password
            </Label>
          </FormGroup>
          {!!this.state.isAutoPassword || (
            <FormGroup row>
              <Label for="password" sm={4}>
                Password:
              </Label>
              <Col sm={10}>
                <Input
                  autocomplete="off"
                  placeholder="Please specify"
                  required
                  type="text"
                  name="password"
                  value={this.state.password}
                  onChange={this.onPasswordValidate}
                  invalid={this.state.showPasswordTip}
                />
                {errors.password && <div className="error-message">{errors.password}</div>}
                <FormFeedback>
                  Password must contain minimum 8 characters and contain minimum 1 lowercase,
                  uppercase, number, and symbol.
                </FormFeedback>
              </Col>
            </FormGroup>
          )}
          <FormGroup style={{ marginLeft: '20px', marginBottom: '4px' }}>
            <Label check>
              <Input
                type="checkbox"
                checked={this.state.resetPassword}
                onChange={this.onPasswordEnabledChange}
              />
              Prompt User to Change Password at First Login
            </Label>
          </FormGroup>
          {/* {!this.hiddenCarrier() ? (
            <FormGroup style={{ marginLeft: '20px', marginBottom: '4px' }}>
              <Label check>
                <Input
                  disabled={this.hiddenCarrier()}
                  type="checkbox"
                  checked={this.state.portingAccessEnabled}
                  onChange={this.onCarrierHubEnabledChange}
                />
                Carrier Hub: Porting Access
              </Label>
            </FormGroup>
          ) : null} */}

          {/* {!this.hiddenCarrier() ? (
          <FormGroup style={{ marginLeft: '20px', marginBottom: '4px' }}>
            <Label check>
              <Input
                disabled={this.hiddenCarrier()}
                type="checkbox"
                checked={this.state.realTimeActivityEnabled}
                onChange={this.onRealTimeActivityChange}
              />
              PCAP Analyzer
            </Label>
          </FormGroup>
        ) : null} */}

          <FormGroup row>
            <Label for="company" sm={4}>
              Company:
            </Label>
            {/* <Col sm={9}>
              {(loggedInUser.role === 'superAdmin' ||
                loggedInUser.role === 'companyGroupAdmin' ||
                loggedInUser.role === 'companyGroupManager') &&
                companies ? (
                <CompanyAutocomplete
                  searchTerm={companyFilter.value}
                  placeholder="Select One"
                  companies={companies}
                  onChange={this.onCompanyFilter}
                />
              ) : (
                <Input
                  disabled={true}
                  type="text"
                  name="company"
                  value={this.props.user.company.name}
                  onChange={this.onAddedUserChange}
                />
              )}
            </Col> */}
            <Col sm={9}>
              {(
                loggedInUser.role === 'superAdmin' ||
                loggedInUser.role === 'companyGroupAdmin' ||
                loggedInUser.role === 'companyGroupManager'
              ) && companies ? (
                <CompanyAutocomplete
                  searchTerm={companyFilter.value}
                  placeholder="Select One"
                  companies={companies}
                  onChange={this.onCompanyFilter}
                />
              // ) : loggedInUser.role === 'enterpriseAdmin' && Array.isArray(this.props.user.memberCompanies) && this.props.user.memberCompanies.length > 0 ? (
              //   <CompanyAutocomplete
              //     searchTerm={companyFilter.value}
              //     placeholder="Select One"
              //     companies={this.props.user.memberCompanies} // Pass memberCompanies as options
              //     onChange={this.onCompanyFilter}
              //   />
            ) : loggedInUser.role === 'enterpriseAdmin' && 
            Array.isArray(this.props.user.memberCompanies) && 
            this.props.user.memberCompanies.length > 0 ? (
              <CompanyAutocomplete
                searchTerm={companyFilter.value}
                placeholder="Select One"
                companies={(() => {
                  const { memberCompanies, company } = this.props.user;
                  const companyExists = memberCompanies.some(c => c.name === company?.name);
                  // Create a new array that includes the user's company if it doesn't exist
                  const updatedCompanies = company?.name && !companyExists 
                    ? [...memberCompanies, { _id: company._id, name: company.name }] 
                    : memberCompanies;
                  return updatedCompanies;
                })()}
                onChange={this.onCompanyFilter}
              />
              ) : (
                <Input
                  disabled
                  type="text"
                  name="company"
                  value={this.props.user.company?.name || ''}
                  onChange={this.onAddedUserChange}
                />
              )}
            </Col>
          </FormGroup>

          <Row>
            <Col sm={12} md={6}>
              <FormGroup row>
                <Label sm={4}>Role:</Label>
                <Col sm={12}>
                  {selectRole && (
                    <DropdownSelect
                      options={this.state.dropdownOptions}
                      selectedOption={selectRole}
                      onSelect={this.onRoleSelect}
                      selectionTrigger={this.state.selectionTrigger}
                      trgiggerText={'superAdmin'}
                    />
                  )} 
                </Col>
              </FormGroup>
            </Col>
            {this.checkPermissionGroupAccess() && <Col sm={12} md={6}>
              <FormGroup row>
                <Label sm={12}>Permission Group:</Label>
                <Col sm={12} md={12}>
                  <Input
                    type="select"
                    id="roleSelect"
                    value={selectedPermissionGroup}
                    onChange={({ target: { value } }) => this.handlePermissionGroup(value)}
                  >
                    <option disabled value="">
                      Select a Group
                    </option>
                    {
                      (permissionGroupsList || []).map((groupKey) => (
                        <option key={groupKey} value={groupKey}>
                          {groupKey}
                        </option>
                      ))
                    }
                  </Input>
                  {errors.permissionsGroup &&
                     <div className="error-message">{errors.permissionsGroup}</div>
                  }
                </Col>
              </FormGroup>
            </Col>}
          </Row>
          <Row>
            <Col sm={12} md={6}>
              <FormGroup row>
                <Label for="enabled" sm={12}>
                  Status:
                </Label>
                <Col sm={5} style={{ display: 'flex', justifyContent: 'flex-end', }}>
                  <Toggle value={this.props.enabled} onToggle={this.onEnabledChange} />
                </Col>
              </FormGroup>
            </Col>
            {/* There is a read only toggle that we need to hide because we don't need it anymore since we have granular permissions. But I was told that we can't remove it completely because there is some backend logic tied to that switch so the thought was let's just hide it from the UI */}
            {/* <Col
              sm={6}
              md={6}
              hidden={
                this.props.role !== 'superAdmin' &&
                this.props.role !== 'companyGroupAdmin' &&
                this.props.role !== 'admin'
              }
            >
              <FormGroup row>
                <Label for="enabled" sm={12}>
                  Read-only:
                </Label>
                <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={this.props.readOnly}
                    onToggle={value => {
                      this.props.addUserChange({ name: 'readOnly', value: !value });
                    }}
                  />
                </Col>
              </FormGroup>
            </Col> */}
          </Row>
          <Row>
            <Col md={6} sm={6} hidden={this.props.role !== 'superAdmin'}>
              <FormGroup row>
                <Label for="enabled" sm={12}>
                  Release Notes Admin:
                </Label>
                <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={this.props.isReleaseNotesAdmin}
                    onToggle={value => {
                      this.props.addUserChange({ name: 'isReleaseNotesAdmin', value: !value });
                    }}
                  />
                </Col>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col
              md={6}
              sm={6}
              hidden={
                // this.props.role !== 'companyGroupAdmin' &&
                // (this.props.user.role === 'companyGroupAdmin' ||
                //   this.props.user.role === 'superAdmin'
                //   )
                (this.props.role !== 'companyGroupAdmin' && this.props.role !== 'companyGroupManager' &&
                  this.props.role !== 'superAdmin'
                )
              }
            >
              <FormGroup row>
                <Label for="enabled" sm={12}>
                  Company Group:
                </Label>
                <Col sm={12} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <OptionalDropdownSelect
                    MultiSelect
                    nameTag="name"
                    filterTag="name"
                    className="testing-filter"
                    placeholder={
                      !(selectedCompanyGroup?.length > 0)
                        ? 'No Company Found'
                        : 'Select Company Group'
                    }
                    dropdownList={selectedCompanyGroup}
                    showFirstListElement
                    onChange={this.selectedCompanies}
                  />
                </Col>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={6} hidden={this.hidden()}>
              <FormGroup row>
                <Label className="font-weight-bold" for="enabled" sm={12}>
                  Access Control:
                </Label>
                <Col sm={12} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <FormGroup style={{ marginLeft: '20px', marginBottom: '1px' }}>
                    <Label check>
                      <Input
                        disabled={userRole !== 'superAdmin'}
                        type="checkbox"
                        checked={this.state.dataCenterMonitor}
                        onChange={this.onDataCenterMonitorChange}
                      />
                      Data Center Monitor
                    </Label>
                  </FormGroup>
                </Col>
                {/* <Col sm={12} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <FormGroup style={{ marginLeft: '20px', marginTop: '10px' }}>
                    <Label check>
                      <Input
                        disabled={userRole !== 'superAdmin'}
                        type="checkbox"
                        checked={this.state.callsAccess}
                        onChange={this.onCallsAccessChange}
                      />
                      Calls Access
                    </Label>
                  </FormGroup>
                </Col> */}
                {/* <Col sm={12} style={{ display: 'flex', verticalAlign: 'middle' }}>
                <FormGroup style={{ marginLeft: '20px', marginBottom: '4px' }}>
                  <Label check>
                    <Input
                      disabled={userRole !== 'superAdmin'}
                      type="checkbox"
                      checked={this.state.deviceMonitor}
                      onChange={this.onDeviceMonitorChange}
                    />
                    Device Monitor
                  </Label>
                </FormGroup>
              </Col> */}
              </FormGroup>
            </Col>
          </Row>
          <AddSecurityCodeModal
            isOpen={this.state.securityModal}
            onCancel={() => {
              this.setState({ securityModal: false, selectionTrigger: 'cancel' });
            }}
            onConfirm={this.onSecurityConfirm}
            superCode
            featureName='superCode'
          />
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.AppState.user,
    loggedInUser: state.AppState.user,
    userRole: state.AppState.user.role,
    name: state.UIState.users.addedUser.name,
    email: state.UIState.users.addedUser.email,
    phoneNumber: state.UIState.users.addedUser.phoneNumber,
    company: state.UIState.users.addedUser.company,
    password: state.UIState.users.addedUser.password,
    enabled: state.UIState.users.addedUser.enabled,
    resetPassword: state.UIState.users.addedUser.resetPassword,
    role: state.UIState.users.addedUser.role,
    companyGroups: state.UIState.users.addedUser.companyGroups,
    readOnly: state.UIState.users.addedUser.readOnly,
    isReleaseNotesAdmin: state.UIState.users.addedUser.isReleaseNotesAdmin,
    companies: state.AppState.companies.docs,
    companyFilter: state.UIState.users.companyFilter,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addUserChange: userData => dispatch(addUserChange(userData)),
    setCompanyFilter: filter => dispatch(addUserCompanyFilter(filter)),
    getCompanies: (token, pagination, disablePaginate) =>
      dispatch(getCompanies(token, pagination, disablePaginate)),
    getCompanyGroup: (token, cid) => dispatch(getCompanyGroup(token, cid)),
  };
};

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(AddUserForm);
const AddUserFormWithRef = forwardRef((props, ref) => (
  <AddUserForm {...props} ref={ref} />
));
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(AddUserForm);